import React from 'react';
import {
  AudienceSongInfoFragmentDoc,
  ContractType,
  type FragmentType,
  getFragment,
  gql,
} from '@graphql/reactQuery';
import { EditionAudience } from './Edition';
import { TieredAudience } from './Tiered';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment AudienceSongInfo on Release {
    id
    numSold
    auctionContractType
    ...ReleaseUpdates
    ...EmptyAudience
    ...HighlightedAudience
  }

  fragment TopAudienceSeat on ReleaseCollector {
    id
    vipNftsCount
    user {
      id
      username
      publicAddress
      webappUri
      avatar {
        id
        url
      }
    }
    ownedGoldenEgg {
      id
    }
    ...TopCommentCard
  }

  fragment EmptyAudience on Release {
    id
    artist {
      id
      userId
    }
    mintStartTimestamp
    listing {
      ... on TieredEditionListing {
        id
        tiers {
          id
          tierNumber
          totalMinted
        }
      }
    }
  }

  query releaseBackersCSVUrl($releaseId: String!) {
    releaseBackersCSVUrl(releaseId: $releaseId)
  }

  query Audience($releaseId: UUID!, $pagination: ReleaseCollectorCursorConnectionArgs!) {
    release(id: $releaseId) {
      id
      collectors(pagination: $pagination) {
        edges {
          node {
            id
            nftsCount
            vipNftsCount
            gaNftsCount
            lowestNftSerialNumber
            user {
              id
              publicAddress
            }
            ...TopAudienceSeat
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`);

export function Audience({
  releaseFrag,
  isFullPage,
  tabsTopOffset,
}: {
  releaseFrag: FragmentType<AudienceSongInfoFragmentDoc>;
  isFullPage: boolean;
  tabsTopOffset: number | undefined;
}) {
  const { auctionContractType } = getFragment(AudienceSongInfoFragmentDoc, releaseFrag);

  const isTieredRelease = auctionContractType === ContractType.TieredEdition;

  if (isTieredRelease) {
    return (
      <TieredAudience
        releaseFrag={releaseFrag}
        isFullPage={isFullPage}
        tabsTopOffset={tabsTopOffset}
      />
    );
  }

  return (
    <EditionAudience
      releaseFrag={releaseFrag}
      isFullPage={isFullPage}
      tabsTopOffset={tabsTopOffset}
    />
  );
}
